"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

// The library is a server-rendered page, so it can't see translation progress
// change on its own. While any book is still preparing, this quietly re-fetches
// the server component on an interval so the loading covers advance and flip to
// "Read" when ready. It unmounts (and stops) once nothing is pending, because
// the next render won't include it.
export default function LibraryAutoRefresh({
  intervalMs = 4000,
}: {
  intervalMs?: number;
}) {
  const router = useRouter();

  useEffect(() => {
    const id = setInterval(() => router.refresh(), intervalMs);
    return () => clearInterval(id);
  }, [router, intervalMs]);

  return null;
}
